import React from 'react'

import {URLS} from '../constants'
import Logo from './common/Logo'
// import Mark from './common/Mark'
import {isAuthenticated, getUser} from '../utils'
// import cn from 'classnames'
import Avatar from './common/Avatar'
import cn from "classnames";

const Header = () => {
    const isAuth = isAuthenticated()
    return (
        <nav className="navbar sticky-top navbar-expand-lg bg-white border-bottom">
            <div className="mr-auto">
            {/*<h5 className="my-0 mr-auto">*/}
                <div className="">
                    <span className="mr-3 d-sm-down-none">
                        <Logo/>
                    </span>
                    {isAuth &&
                    <div className="btn-group" role="group" aria-label="Button group">
                        <span><a className="navbar-menu-item" href="/dashboard">Sessions</a></span>
                        <span className="mx-3">{getUser().isOrganizationAdmin? <a className="navbar-menu-item" href="/org-settings">Settings</a> : null}</span>
                    </div>
                    }
                </div>
            </div>

            {isAuth ? (
                <div className="">
                    <span className="d-sm-down-none">
                        <span className={cn('badge', getUser().isOrganizationAdmin ? 'badge-primary' : 'badge-secondary')}>{getUser().isOrganizationAdmin?'Admin':'User'}</span>
                        {/*{getUser().isOrganizationAdmin && ( <span className="badge badge-pill badge-primary">Admin</span>)}*/}
                        {/*{!getUser().isOrganizationAdmin && ( <span className="badge badge-pill badge-secondary">User</span>)}*/}
                         <span className="ml-3"><Avatar width={30} src={getUser().slackImage48} /> </span>
                    </span>
                    <a className="navbar-menu-item ml-3" href={URLS.LOGOUT}>
                        Log out
                    </a>
                </div>
            ) : (
                <a className="btn btn-outline-primary" href={URLS.LOGIN}>
                    Sign In
                </a>
            )}
            {/*</div>*/}
        </nav>
    )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.jsx